import { useQuery } from "@apollo/client";
import { graphql } from "~/gql";

export const FIND_ALL_BRANDS = graphql(/* GraphQL */ `
  query findAllBrands {
    findAllBrands {
      __typename
      id
      organisationName
      organisationLogo
      footer
      includeTasksInProposalOutput
      includeRatesInProposalOutput
      proposalFont
      isDefault
      numberedListFormat
    }
  }
`);

export function useBrandsQuery() {
  return useQuery(FIND_ALL_BRANDS);
}
